module.exports = __webpack_public_path__ + "static/media/m3cr54.ff971912.png";